import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { PopupCall } from "./PopupCall";
import { PopupClientEdit } from "./PopupClientEdit";
import { routes } from "../utils/symbols";
import { t } from "../i18n";
import { Icon } from "../components/Icon";
import { PopupError } from "./PopupError";
import { ProgressBar } from "./ProgressBar";
import { useBookingNavigation } from "../hooks/useBookingNavigation";

export const Footer = ({ nextPage, previousPage, clearOnBack = [] }) => {
	const {
		openPopUpCall,
		openPopUpError,
		route,
		navigate,
		data,
		setData,
		setIsTransitioning,
		validateForm,
		flow,
	} = useContext(AppContext);
	const [disabledButton, setDisabledButton] = useState(false);

	const { executeNext, sending } = useBookingNavigation({
		route,
		nextPage,
		data,
		setData,
		flow,
		navigate,
		openPopUpError,
		setIsTransitioning,
		validateForm,
	});

	useEffect(() => {
		let isDisabled = false;
		if (sending) {
			isDisabled = true;
		}

		if (
			route === routes.bookingForm &&
			flow !== "mapfre" &&
			(!data.phone || data.phone === "+34" || !data.plate || !data.privacy_policy)
		)
			isDisabled = true;
		if (
			route === routes.bookingForm &&
			flow === "mapfre" &&
			(!(data.userName || data.name) ||
				!(data.phoneNumber || data.phone) ||
				!(data.userEmail || data.email) ||
				!(data.plateNumber || data.plate) ||
				!data.workCenterCode)
		)
			isDisabled = true;
		if (route === routes.selectCenter && !data.centerId) isDisabled = true;
		if (route === routes.damageGlass && !data.damageGlass) isDisabled = true;
		if (
			route === routes.damageGlassMoreInfo &&
			!data.damageGlassMoreInfo
		)
			isDisabled = true;
		if (route === routes.damageType && !data.damageType) isDisabled = true;
		if (route === routes.damageArea && !data.damageArea) isDisabled = true;
		if (
			route === routes.selectDateTime &&
			(!data.date || !data.startTime || !data.time)
		)
			isDisabled = true;
		if (
			route === routes.bookingEnd &&
			(!data.plate ||
				!data.brand ||
				!data.model ||
				(flow === "web" &&
					(!(data.insurance || data.noInsurance) ||
						data.insurance.toLowerCase() === "web")) ||
				!data.email ||
				!data.name ||
				!data.phone || data.phone === "+34" ||
				!data.privacy_policy_2)
		)
			isDisabled = true;

		setDisabledButton(isDisabled);
	}, [route, data, sending, flow]);

	const goToPreviousPage = () => {
		if (clearOnBack.length) {
			const reset = clearOnBack.reduce(
				(acc, field) => ({ ...acc, [field]: null }),
				{},
			);
			setData((prev) => ({ ...prev, ...reset }));
		}
		setIsTransitioning(false);
		navigate(previousPage);
	};

	return (
		<>
			<footer className="footer">
				<ProgressBar />
				<div className="footer_wrapper">
					<div className="footer_left">
						<button
							onPointerDown={openPopUpCall}
							className={
								"footer_call" +
								(!data.locator ? " disabled" : "")
							}
						>
							<Icon name="telephone" className="footer_icon" />
							<p className="footer_p footer_p_call">{t("Te llamamos")}</p>
						</button>
					</div>
					<div className="footer_right">
						<button
							className={
								"nav_previous kensei_03" +
								(!data.locator ||
									route === routes.bookingForm ||
									(flow === "mapfre" &&
										data.locator &&
										route === routes.intro)
									? " disabled"
									: "")
							}
							onPointerDown={goToPreviousPage}
						>
							<Icon name="arrow" className="footer_icon" />
						</button>
						<button
							className={
								"nav_next kensei_03" +
								(disabledButton ? " disabled" : "")
							}
							onPointerDown={executeNext}
						>
							{(route === routes.selectDateTime &&
								flow === "mapfre") ||
								(route === routes.bookingEnd &&
									flow !== "mapfre") ? (
								<p className="footer_p">{t("Confirmar")}</p>
							) : (
								<p className="footer_p">{t("Adelante")}</p>
							)}
							<Icon name="arrow" className="footer_icon" />
						</button>
					</div>
				</div>
			</footer>

			{flow !== "web" && flow !== "mapfre" && (
				<div className="sub_footer_caser">
					<div className="container">
						<div className="footer_heading">
							<div className="footer_logo">
								<img
									src="https://www.ralarsa.com/wp-content/themes/ralarsa/img/brand/logo-ralarsa-white.svg"
									alt="Logo Ralarsa"
								/>
							</div>
							<div className="link_phone">
								<a
									href={
										flow === "allianz-direct"
											? "tel:+34647444848"
											: "tel:+34673780011"
									}
									className="call-btn"
									data-location="footer"
									data-origin="geo"
									data-phone={
										flow === "allianz-direct"
											? "647 444 848"
											: "673 780 011"
									}
								>
									<img
										src="resources/icons/telephone_lime.svg"
										alt="Llamar"
									/>
									{flow === "allianz-direct" ? (
										<span>647 444 848</span>
									) : (
										<span>673 780 011</span>
									)}
								</a>
							</div>
						</div>
						<div className="footer_companies">
							<div id="cary_group">
								<span>{t("Parte de")}</span>
								<img
									src="resources/img/cary_group.png"
									alt=""
									title=""
								/>
							</div>
							<div id="centro_zaragoza">
								<span>{t("Certificados por")}</span>
								<img
									src="resources/img/centro_zaragoza.png"
									alt=""
									title=""
								/>
							</div>
						</div>
					</div>
					<div className="sub_footer">
						<div className="footer_legal">
							<div className="copiright">
								<span>
									{t(
										"© 2026 Ralarsa. Todos los derechos reservados.",
									)}
								</span>
							</div>
							<div className="legal_menu">
								<a href="https://www.ralarsa.com/es/aviso-legal/">
									{t("Aviso legal")}
								</a>
								<a href="https://www.ralarsa.com/es/privacidad/">
									{t("Política privacidad")}
								</a>
								<a href="https://www.ralarsa.com/es/politica-de-cookies/">
									{t("Política de cookies")}
								</a>
							</div>
						</div>
					</div>
				</div>
			)}

			<PopupCall />
			{flow === "mapfre" && <PopupClientEdit />}
			<PopupError />
		</>
	);
};
